import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import type { PlanCadence, PlanCard } from './models';

@Component({
    selector: 'qpx-publish-plan-options',
    imports: [MatRadioModule],
    templateUrl: './plan-options.html',
    styleUrl: './plan-options.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'block',
    },
})
export class PublishPlanOptions {
    public readonly cards = input.required<readonly PlanCard[]>();
    public readonly selectedCadence = input.required<PlanCadence>();
    public readonly selectedCadenceChange = output<PlanCadence>();

    protected planOptionId(cadence: PlanCadence): string {
        return `publish-plan-${cadence}`;
    }

    protected selectCadence(cadence: PlanCadence): void {
        this.selectedCadenceChange.emit(cadence);
    }
}
